import { Chip } from "@mui/material";
import { NameAndId } from "../../data/NameAndId";
import { useTemplateContext } from "./TemplateContext";
import { useMemo } from "react";

type TemplateCategoryChipViewProps = {};

export const TemplateCategoryChipView = ({}: TemplateCategoryChipViewProps) => {
  const {
    state: { categoryId, isClientType },
    apiTemplates,
    changeCategory: categoryChanged,
  } = useTemplateContext();

  const handleClick = (item: NameAndId) => {
    if (item.id === categoryId) categoryChanged(undefined);
    else categoryChanged(item.id);
  };
  const categories = useMemo(() => {
    return isClientType ? apiTemplates?.savedCategories : apiTemplates?.defaultCategories;
  }, [apiTemplates, isClientType]);
  if (!categories) return <div></div>;
  return (
    <div
      style={{
        alignSelf: "center",
        overflow: "scroll",
        display: "flex",
        flexWrap: "wrap",
        gap: "0.625rem",
        alignItems: "center",
      }}
    >
      {[{ name: "All", id: undefined }, ...categories].map((item, index) => (
        <CategoryChip key={item.name} item={item} selected={categoryId === item.id} onClick={() => handleClick(item)} />
      ))}
    </div>
  );
};

const CategoryChip = ({ item, selected, onClick }) => {
  return <Chip key={item.id} label={item.name} sx={{ padding: "4px 16px", fontSize: "14px", fontWeight: 500 }} clickable color={selected ? "secondary" : "default"} onClick={onClick} />;
};

export const distinctValues = (data: NameAndId[]) => {
  return data.filter((thing, i, arr) => arr.findIndex((t) => t.id === thing.id) === i);
};
